<onboarding-container
  [formValid]="formValid$ | async"
  [loading]="(facade.sendingPhoneNumber$ | async) || (facade.verifyingCode$ | async)"
  (forward)="goForward()"
  (back)="goBack()"
  [hideBack]="(step$ | async) !== Step.VERIFY_NUMBER"
  [buttonLabel]="(step$ | async) === Step.VERIFY_NUMBER ? ('onboarding.mobile-number.code.button-label' | transloco) : null"
>
  @if ((step$ | async) === Step.NUMBER_VERIFIED) {
    @if (activeCountry$ | async; as activeCountry) {
      @if (mobileNumber$ | async; as mobileNumber) {
        <ng-container *ngTemplateOutlet="mobileNumberVerified; context: { mobileNumber: activeCountry.phoneCode + mobileNumber }" />
      }
    }
  } @else {
    <ng-container *ngTemplateOutlet="default" />
  }
</onboarding-container>

<ng-template #default>
  <p class="zero-text p-huge-med">{{ 'onboarding.mobile-number.pre' | transloco }}</p>
  <p class="zero-text p-huge-med">{{ 'onboarding.mobile-number.headline' | transloco }}</p>
  <p class="zero-text p-base-reg">{{ 'onboarding.mobile-number.hint' | transloco }}</p>
  @if (activeCountry$ | async; as activeCountry) {
    <div class="d-block d-md-flex gap my-4">
      <ng-container *ngTemplateOutlet="dropdown; context: { activeCountry }" />
      <web-design-system-input
        type="number"
        class="flex-auto"
        (valueChange)="onMobileNumberChange($event)"
        [fixedLabel]="activeCountry.phoneCode + ' (0)'"
        [label]="'onboarding.mobile-number.label' | transloco"
        [value]="mobileNumber$ | async"
        [isValid]="mobileNumber$ | async | phone: activeCountry.phoneCode"
        [disabled]="(step$ | async) === Step.VERIFY_NUMBER"
        [error]="
          (mobileNumber$ | async | phone: activeCountry.phoneCode) === false
            ? ('onboarding.mobile-number.error' | transloco: { countyCode: activeCountry.phoneCode + ' (0)' })
            : null
        "
      />
    </div>
    @if ((step$ | async) === Step.VERIFY_NUMBER) {
      <p class="zero-text p-huge-med">{{ 'onboarding.mobile-number.code.headline' | transloco }}</p>
      <p class="zero-text p-base-reg">
        {{ 'onboarding.mobile-number.code.hint-start' | transloco }}
        <a class="zero-text link" (click)="goBack()">{{ activeCountry.phoneCode + (mobileNumber$ | async) }}</a>
        {{ 'onboarding.mobile-number.code.hint-end' | transloco }}
      </p>
      <web-design-system-input
        class="d-block mb-3"
        type="text"
        (valueChange)="onCodeChange($event)"
        [label]="'onboarding.mobile-number.code.label' | transloco"
        [value]="code$ | async"
        [isValid]="code$ | async | verificationCode"
        [error]="(facade.sentCodeSuccessfully$ | async) === false ? ('onboarding.mobile-number.code.error' | transloco) : null"
      />

      <div class="d-flex align-items-center">
        <a
          class="zero-text link d-block"
          [class.not-allowed]="hasResendCodeError || !isResendEnabled"
          (click)="!hasResendCodeError && isResendEnabled && facade.resendCode()"
          (mouseover)="onHoverResend = true"
          (mouseout)="onHoverResend = false"
          >{{ 'onboarding.mobile-number.code.resend' | transloco }}</a
        >
        <div class="countdown-container ml-2" [class.active]="!hasResendCodeError && !isResendEnabled && onHoverResend">
          <div class="countdown-number">
            {{ resendEnabledCountdown }}
          </div>
          @if (resendEnabledCountdown) {
            <svg class="countdown-icon">
              <circle r="9" cx="10" cy="10" />
            </svg>
          }
        </div>
      </div>
      @if (facade.resendCodeError$ | async; as resendCodeError) {
        <p class="zero-text p-base-reg course-red mt-3">{{ resendCodeError }}</p>
      }
    }
  }
</ng-template>
<ng-template #mobileNumberVerified let-mobileNumber="mobileNumber">
  <p class="zero-text p-huge-med">{{ 'onboarding.mobile-number.verified.headline' | transloco }}</p>
  <p class="zero-text p-base-reg">{{ 'onboarding.mobile-number.verified.hint' | transloco: { mobileNumber } }}</p>
</ng-template>

<ng-template #dropdown let-activeCountry="activeCountry">
  <div ngbDropdown class="d-block mb-3 mb-md-0">
    <button ngbDropdownToggle [disabled]="(step$ | async) === Step.VERIFY_NUMBER">
      {{ activeCountry.fullName }}
      <web-design-system-icon name="chevron-2" size="small" />
    </button>
    <div ngbDropdownMenu>
      <web-design-system-input
        class="d-block"
        [icon]="'magnifier'"
        [(value)]="countryFilter"
        [label]="'onboarding.mobile-number.dropdown.placeholder' | transloco"
      />
      @if (facade.countries$ | async | countryFilter: countryFilter; as countries) {
        @if (countries.length === 0) {
          <div class="mt-3 zero-text p-small-reg">{{ 'onboarding.mobile-number.dropdown.no-results' | transloco }}</div>
        } @else {
          @for (country of countries; track country.isoCode) {
            <div class="suggestion" (click)="selectCountry(country)" ngbDropdownItem>{{ country.fullName }}</div>
          }
        }
      }
    </div>
  </div>
</ng-template>
